export { SpotlightQAContainer as SpotlightQA } from "./SpotlightQAContainer";
export { Spotlight } from "./types";
